/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --nve-sys-interaction-background: var(--nve-sys-interaction-background-200);
  --nve-sys-interaction-field-background: var(--nve-sys-interaction-background-200);
  --background: var(--nve-sys-layer-container-background);
  --color: var(--nve-sys-layer-canvas-color);
  --border-radius: 0;
  --header-padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  --cursor: pointer;
  --transition: height var(--nve-ref-animation-duration-200) ease-in-out;
  width: 100%; /* fallback safari */
  width: stretch;
  contain: none;
}

[internal-host] {
  border-radius: var(--border-radius);
  background: var(--background);
  color: var(--color);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  height: 100%;
}

#header {
  cursor: var(--cursor);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: var(--header-padding);
}

#content {
  display: block;
  height: 0;
  transition: var(--transition);
}

:host(:state(expanded)) #content {
  /* fallback for browsers that do not support intrinsic sizing keywords with calc-size() */
  height: auto;

  /* https://developer.chrome.com/docs/css-ui/animate-to-height-auto#animate_to_and_from_intrinsic_sizing_keywords_with_calc-size */
  height: calc-size(max-content, size);
}

:host([container='inset']) {
  --border-radius: var(--nve-ref-border-radius-md);
}

:host([container='flat']) {
  --background: inherit;
}

:host([disabled]) {
  --cursor: not-allowed;
}

:host([disabled]) ::slotted(nve-accordion-header) {
  --cursor: not-allowed;
}

:host(:not([disabled])) #header:hover nve-icon-button {
  --color: var(--nve-sys-text-emphasis-color);
}

nve-icon-button::part(icon) {
  transition: transform var(--nve-ref-animation-duration-200) cubic-bezier(0.4, 0, 0.2, 1);
}
